import { rangesState } from "components/organisms/manuscript/overleaf/ot/historyOt";

export function trackedDeletesFromState(state) {
    return new TrackedDeletes(state.field(rangesState).trackedChanges);
}

export class TrackedDeletes {
    constructor(trackedChanges) {
        this.offsets = {
            toCM6: [{ pos: 0, map: (pos) => pos }],
            toSnapshot: [{ pos: 0, map: (pos) => pos }],
        };

        let offset = 0;
        for (const change of trackedChanges.asSorted()) {
            if (change.tracking.type !== "delete") {
                continue;
            }

            const deleteLength = change.range.length;
            const deletePos = change.range.pos;
            const oldOffset = offset;
            const newOffset = offset + deleteLength;

            this.offsets.toSnapshot.push({
                pos: change.range.pos - offset + 1,
                map: (pos) => pos + newOffset,
            });
            this.offsets.toCM6.push({
                pos: change.range.pos,
                map: () => deletePos - oldOffset,
            });
            this.offsets.toCM6.push({
                pos: change.range.pos + deleteLength,
                map: (pos) => pos - newOffset,
            });
            offset = newOffset;
        }
    }

    toCodeMirror(snapshotPos) {
        return this.mapPos(snapshotPos, this.offsets.toCM6);
    }

    toSnapshot(cm6Pos) {
        return this.mapPos(cm6Pos, this.offsets.toSnapshot);
    }

    mapPos(pos, offsets) {
        let low = 0;
        let high = offsets.length - 1;

        while (low < high) {
            const middle = Math.ceil((low + high) / 2);
            const entry = offsets[middle];
            if (entry.pos < pos) {
                low = middle;
            } else if (entry.pos > pos) {
                high = middle - 1;
            } else {
                return entry.map(pos);
            }
        }

        return offsets[low].map(pos);
    }
}

export default TrackedDeletes;
